import { CalendarResponseResponseBuilder } from 'gql/autogen/CalendarResponseResponseBuilder';
import { CalendarActivityResultResponseBuilder } from 'gql/autogen/CalendarActivityResultResponseBuilder';
import { AvailabilityCalendarResponseBuilder } from 'gql/autogen/AvailabilityCalendarResponseBuilder';
import { AvailabilityScheduleResponseBuilder } from 'gql/autogen/AvailabilityScheduleResponseBuilder';
import { AdditionalScheduleInfoResponseBuilder } from 'gql/autogen/AdditionalScheduleInfoResponseBuilder';
import { buildSearchErrorResponse } from 'gql/activityBuilder/commonQueryBuilders';
import { OfferCalendarResponseBuilder } from 'gql/autogen/OfferCalendarResponseBuilder';

const build = (): CalendarResponseResponseBuilder => {
    return new CalendarResponseResponseBuilder()
        .withIsSuccess()
        .withResult(
            new CalendarActivityResultResponseBuilder()
                .withIsCompleted()
                .withCalendar(
                    new AvailabilityCalendarResponseBuilder()
                        .withMasterActivityId()
                        .withMasterSupplierId()
                        .withCurrency()
                        .withStartDate()
                        .withEndDate()
                        .withSchedules(new AvailabilityScheduleResponseBuilder().withDate().withPrice().withIsAvailable().withStatus())
                        .withAdditionalInfo(new AdditionalScheduleInfoResponseBuilder().withCheapestDates())
                        .withOffersCalendar(
                            new OfferCalendarResponseBuilder()
                                .withOfferId()
                                .withSchedules(new AvailabilityScheduleResponseBuilder().withDate().withPrice().withIsAvailable().withStatus()),
                        ),
                ),
        )
        .withErrors(buildSearchErrorResponse());
};

export default build;
